import * as tslib_1 from "tslib";
import { HttpClient } from '@angular/common/http';
import { FileUploadService } from '@services/file.upload.service';
import { ODataService } from '@services/generics/odata.service';
import { MapperService } from '@services/mapper.service';
var PackageService = /** @class */ (function (_super) {
    tslib_1.__extends(PackageService, _super);
    function PackageService(http, _fileUploadService) {
        var _this = _super.call(this, http, MapperService.packageMap) || this;
        _this._fileUploadService = _fileUploadService;
        _this._endpoint = 'odata/Processes';
        return _this;
    }
    PackageService.prototype.getVersions = function (packageId, queryOptions) {
        return this.get(queryOptions, "/odata/Processes/UiPath.Server.Configuration.OData.GetProcessVersions(processId='" + packageId + "')");
    };
    PackageService.prototype.uploadPackages = function (files) {
        return this._fileUploadService.uploadFiles(files, '/odata/Processes/UiPath.Server.Configuration.OData.UploadPackage()');
    };
    PackageService.prototype.downloadLink = function (entry) {
        return this._endpoint + "/UiPath.Server.Configuration.OData.DownloadPackage(key='" + entry.key + "')";
    };
    PackageService.prototype.download = function (packageKey) {
        var url = this._endpoint + "/UiPath.Server.Configuration.OData.DownloadPackage(key='" + packageKey + "')";
        return this._http.get(url, { headers: { 'content-type': 'application/octet-stream' }, responseType: 'arraybuffer' });
    };
    return PackageService;
}(ODataService));
export { PackageService };
